import { apiRequest } from './httpClient';

/**
 * Records that the signed-in user accepts the current terms.
 *
 * Sends no version. The server decides which text is in force and
 * writes that - a client that names its own version could claim
 * agreement to wording it was never shown. Returns the updated user, so
 * the caller can refresh auth state without a second round trip.
 */
export function acceptTerms() {
  return apiRequest('/api/users/me/accept-terms', { method: 'POST' });
}
